<!-- Upload Image box -->
<div *ngIf="!imageUrl && blockElement?.isActiveForEdit">
  <div class="default-img-drop-block">
    <app-input [inputType]="'file'" [acceptFormat]="'image/*'" [fieldValue]="" [fieldText]=""
      [fControl]="formGroup.controls['Image']" [isRequired]="false" (change)="onFileSelected($event)"></app-input>
    <div class="upload-inner">
      <img src="./assets/images/ic-upload.svg" alt="Icon">
      <span>Upload Your Image</span>
    </div>
  </div>
</div>
<div>
  <div *ngIf="imageUrl && blockElement?.isActiveForEdit" class="img-drop-block edit-mode">
    <div class="mockup-wrap">
      <!-- Edit main image box-->
      <image-cropper [imageChangedEvent]="imageChangedEvent" [imageURL]="imageUrl" [maintainAspectRatio]="true"
        [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="selectedValue" [cropperMinWidth]="128"
        [onlyScaleDown]="true" [roundCropper]="false" [alignImage]="'center'"
        [style.display]="showCropper ? null : 'none'" [allowMoveImage]="allowMoveImage" [hidden]="hidden"
        imageAltText="Alternative image text" output="blob" format="jpeg" (imageCropped)="imageCropped($event)"
        (imageLoaded)="imageLoaded()"></image-cropper>
    </div>
    <div *ngIf="imageUrl && blockElement?.isActiveForEdit" class="image-action-block">
      <div class="btn-grps" *ngFor="let ratio of aspectRatios" [ngStyle]="{'display':showCropOptions?'block':'none'}">
        <app-radio-button [id]="'op-' + ratio.value" name="crop-options" [value]="ratio.value" [label]="ratio.label"
          [isChecked]="selectedValue==ratio.value" (selectionChanged)="onChange($event)">
        </app-radio-button>
      </div>
      <div class="save-edit-block">
        <app-button *ngIf="!showCropOptions" [btnCss]="'btn btn-action'" [btnText]="'crop'"
          (onBtnClick)="showCropOptions=true;" [btnTitle]="'crop'">
          <img src="./assets/images/ic-crop.svg" alt="Icon">
        </app-button>
        <app-button [btnCss]="'btn btn-action'" [btnText]="'save'" (onBtnClick)="save($event)" [btnTitle]="'save'">
          <img src="./assets/images/ic-true.svg" alt="Icon">
        </app-button>
        <app-button [btnCss]="'btn btn-action'" [btnText]="'cancel'"
          (onBtnClick)="openDiscardChangesModal(discardChangesModalUpload,$event)" [btnTitle]="'cancel'">
          <img src="./assets/images/ic-false.svg" alt="Icon">
        </app-button>
      </div>
    </div>
  </div>
  <div *ngIf="!blockElement?.isActiveForEdit" class="img-drop-block edit-mode">
    <div class="mockup-wrap">
      <!-- View Image box-->
      <img [src]="blockElement?.data" class="main-img">
    </div>
  </div>
</div>

<!-- Discard changes model -->
<ng-template #discardChangesModalUpload let-modal>
  <div class="modal-head">
    <button class="btn btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="img-wrap">
      <img src="./assets/images/ic-delete-section.svg" alt="Icon" />
    </div>
    <h2 class="title-text" ngbAutofocus>
      Are you sure, you want to discard the changes?
    </h2>
    <div class="btn-grps">
      <button class="btn btn-outline-primary" title="No" (click)="modal.close(false)">No</button>
      <button class="btn btn-primary" (click)="modal.close(true)" title="Yes">Yes</button>
    </div>
  </div>
</ng-template>